module.exports = __webpack_public_path__ + "static/media/poppins-v5-latin-ext-regular.6fc407b7.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/poppins-v5-latin-ext-regular.woff2
// module id = ./src/common/fonts/poppins-v5-latin-ext-regular.woff2
// module chunks = 1